import { CreateTxOptions, MsgExecuteContract } from '@terra-money/terra.js'
import BigNumber from 'bignumber.js'
import { TokenInfoResponse } from 'interfaces/contracts/cw20token'
import { BaseLcdService } from './base/baseLcdService'

export class CW20Service extends BaseLcdService {
  getBalance = async (tokenAddr: string, targetAddr: string) => {
    const msg = {
      balance: {
        address: targetAddr,
      },
    }

    const { decimals } = await this.getTokenInfo(tokenAddr)
    const { balance } = await this.contractQuery(tokenAddr, msg)

    return new BigNumber(balance).div(`1e${decimals}`)
  }

  getTokenInfo = async (tokenAddr: string) => {
    const msg = {
      token_info: {},
    }
    const response = await this.contractQuery<TokenInfoResponse>(tokenAddr, msg)
    return response
  }

  getAllowance = (owner: string, spender: string) => {
    return {
      allowance: {
        owner,
        spender,
      },
    }
  }

  increaseAllowance = (
    owner: string,
    tokenAddr: string,
    spender: string,
    amount: string = '10000000000000000000000000',
  ): CreateTxOptions => {
    return {
      msgs: [
        new MsgExecuteContract(owner, tokenAddr, {
          increase_allowance: {
            spender: spender,
            amount, // MAX NUMBER?
            // Set as never expire
            expires: {
              never: {},
            },
          },
        }),
      ],
    }
  }
}

export const cw20Service = new CW20Service()
